import { render, staticRenderFns } from "./classTable.vue?vue&type=template&id=27d2d734&scoped=true"
import script from "./classTable.vue?vue&type=script&lang=js"
export * from "./classTable.vue?vue&type=script&lang=js"
import style0 from "./classTable.vue?vue&type=style&index=0&id=27d2d734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d2d734",
  null
  
)

export default component.exports